import React, { PropsWithChildren } from "react";
import { CommonSection } from "./CommonSection";
import { QuoteArrayFields } from "./QuoteArrayFields";

export const QuoteForm = ({ children }: PropsWithChildren<{}>) => (
  <>
    <CommonSection />
    {children}
    <QuoteArrayFields equipmentId={null} />
  </>
);
